import { QueryClient } from '@tanstack/react-query'
import { CampaignUpdatedEvent } from 'types/pushNotifications'

export const handleCampaignUpdated = async (
  event: CampaignUpdatedEvent,
  queryClient: QueryClient,
  invalidateCampaigns: ((agencyId: string) => Promise<void>)[]
) => {
  if (!event.agencyId) return
  if (!event.campaignId) return

  await Promise.all([
    queryClient.invalidateQueries({
      predicate: (query) =>
        Array.isArray(query.queryKey) &&
        query.queryKey.includes(event.campaignId),
    }),
    ...invalidateCampaigns.map((fn) => fn(event.agencyId)),
  ])
}
